/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MaintenanceInfo } from './MaintenanceInfo';
export type AggregatedSestData = {
  /**
   * 순서
   */
  order: number;
  /**
   * * 소모품 카테고리 | 1: 엔진, 2: 제동, 3: 공조, 4: 냉각수
   */
  categoryNo: number;
  /**
   * * 소모품 코드
   */
  sestCode: string;
  /**
   * * 소모품 명
   */
  sestName: string;
  /**
   * * 경고등점등(0: 미점등, 1: 점등)
   * @deprecated
   */
  warningLight: number;
  /**
   * * 교체정보
   */
  maintenanceInfos: Array<MaintenanceInfo>;
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DATE)
   */
  maintenanceType: AggregatedSestData.maintenanceType;
  /**
   * 최근 교환 일시
   */
  replaceDate: string;
  /**
   * 최근 교환 시점 누적주행
   */
  replaceOdometer: number;
  /**
   * 해당 데이터의 업데이터 날짜
   */
  updateDate: string;
  /**
   * 최근 교환 정보의 출처 (0: HSW, 1: 사용자 입력)
   */
  sourceType: AggregatedSestData.sourceType;
  /**
   * 고도화 콘텐츠 지원 여부
   */
  contentLevel: AggregatedSestData.contentLevel;
};
export namespace AggregatedSestData {
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DATE)
   */
  export enum maintenanceType {
    COMBINED = 'COMBINED',
    DISTANCE = 'DISTANCE',
    DAY = 'DAY',
  }
  /**
   * 최근 교환 정보의 출처 (0: HSW, 1: 사용자 입력)
   */
  export enum sourceType {
    SERVICE_CENTER = 'SERVICE_CENTER',
    USER = 'USER',
    DEFAULT = 'DEFAULT',
    PREDICTION = 'PREDICTION',
    ADMIN = 'ADMIN',
  }
  /**
   * 고도화 콘텐츠 지원 여부
   */
  export enum contentLevel {
    GENERAL = 'GENERAL',
    ADVANCED = 'ADVANCED',
  }
}

